// extracted by mini-css-extract-plugin
export default {"badge":"timeBadge-module__badge--vI2dm","timer":"timeBadge-module__timer--FWhTi","period":"timeBadge-module__period--F_Aha"};